document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-glass-feature').forEach(function (section) {
    var prevBtn = section.querySelector('[data-glass-prev]');
    var nextBtn = section.querySelector('[data-glass-next]');
    var dots = section.querySelectorAll('[data-glass-dot]');

    var leftPanels = section.querySelectorAll('.custom-glass-feature__left');
    var rightPanels = section.querySelectorAll('.custom-glass-feature__right');
    var bgImages = section.querySelectorAll('[data-glass-bg]');
    var total = leftPanels.length;

    if (total <= 1) return; // single slide, nothing to wire up

    var current = 0;
    var autoplayTimer = null;
    var autoplaySeconds = parseFloat(section.getAttribute('data-glass-autoplay') || '0');

    function show(index) {
      current = (index + total) % total;

      leftPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-glass-slide') === String(current));
      });
      rightPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-glass-slide') === String(current));
      });
      bgImages.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-glass-bg') === String(current));
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-glass-dot') === String(current));
      });
    }

    function startAutoplay() {
      if (autoplaySeconds > 0) {
        autoplayTimer = setInterval(function () {
          show(current + 1);
        }, autoplaySeconds * 1000);
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    // Any manual interaction resets the autoplay timer, so it doesn't
    // advance immediately after someone navigates themselves.
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(current - 1);
        restartAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(current + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-glass-dot'), 10));
        restartAutoplay();
      });
    });

    startAutoplay();
  });
});